export default __webpack_public_path__ + "static/media/current.6f4088f3.svg";